export enum DatabasesToSearch {
    Private = "private",
    Public = "public"
}